.radio-pills {
  display: inline-flex;
  max-width: 100%;
  gap: var(--rc-theme-spacing-xs);
}

.radio-pills--margin-bottom {
  margin-bottom: var(--rc-theme-spacing-ms);
}

.radio-pills__item {
  border-radius: var(--rc-theme-border-radius-xl);
  border-color: transparent;
  background-color: var(--rc-theme-color-surface-subtle);
  white-space: nowrap;

  :global(.ant-wave) {
    display: none;
  }

  &:first-child {
    border-inline-start-color: transparent;
  }

  &:first-child,
  &:last-child {
    border-radius: var(--rc-theme-border-radius-xl);
  }

  &:hover:not(:has(input:disabled)) {
    border-color: var(--rc-theme-color-primary-default);
    color: var(--rc-theme-color-text-default);
  }

  &&:has(input:checked) {
    border-color: var(--rc-theme-color-primary-default);
    background-color: var(--rc-theme-color-primary-default6);
    color: var(--rc-theme-color-primary-default);

    .radio-pills__icon {
      color: var(--rc-theme-color-primary-default);
    }

    &:hover {
      border-color: var(--rc-theme-color-primary-default);
      color: var(--rc-theme-color-primary-default);
    }
  }

  &:has(input:disabled) {
    background-color: var(--rc-theme-color-surface-subtle);
    color: var(--rc-theme-color-text-disabled);

    .radio-pills__icon {
      color: var(--rc-theme-color-text-disabled);
    }
  }
}
